import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/ReLowCode_Logo.png")